import React from "react";
import "./scss/Tabs.scss";

const TabsBody = ({ children, activeTab, className = "" }) => {
  return (
    <div className={`row ${className}`}>
      {React.Children.map(children, (child, index) => (
        <div
          className={`col col-12 tab-container`}
          style={{ display: index === activeTab ? "block" : "none" }}
        >
          {child}
        </div>
      ))}
    </div>
  );
};

export default TabsBody;
